import React from "react";

type Props = {};

const Section89ANCHint: React.FC<Props> = (props: Props) => {
  return (
    <>
      <p className="leading-para text-greyDark text-start">
        Report income earned in retirement benefits account covered under section 89A maintained in
        any of the notified countries i.e. United States Of America, United Kingdom, Canada.
      </p>
    </>
  );
};

export default Section89ANCHint;
